import { Box, List, ListItem, ListItemText, Stack, Typography } from '@mui/material';
import cx from 'clsx';

import styles from './InfoItem.module.scss';

interface InfoItemProps {
  title: string;
  items: string[];
  variant: 'blue' | 'green' | 'pink';
}

const InfoItem = ({ title, items, variant }: InfoItemProps) => (
  <Box className={styles.container}>
    <Box className={cx(styles.line, styles[variant])} />
    <Stack>
      <Typography variant="body1" component="p">
        {title}
      </Typography>
      <List className={styles.list}>
        {items.map(item => (
          <ListItem key={item} className={styles.item}>
            <ListItemText>
              <Typography variant="subtitle1" component="p">
                {item}
              </Typography>
            </ListItemText>
          </ListItem>
        ))}
      </List>
    </Stack>
  </Box>
);

export default InfoItem;
